import axios from 'axios'
import { omitBy, isNil } from 'lodash'
import { PassportClient } from '@chronobank/passport.client'

import configProvider from 'src/configProvider'

const config = configProvider.getConfig()


export const withAuthorization = (authorization, config = {}) => ({
  ...config,
  headers: {
    ...config.headers,
    Authorization: `Bearer ${authorization}`
  }
})

export const withAuthorizationAndVerification = (authorization, verification, config = {}) => ({
  ...config,
  headers: {
    ...config.headers,
    ...omitBy({
      'authorization': authorization == null ? null : `Bearer ${authorization}`,
      'x-passport-otp': verification == null ? null : `APP ${verification}`
    }, isNil)
  }
})
export const PASSPORT = axios.create(config.passportService.passport.endpoint)
export const PASSPORT_CLIENT = new PassportClient(config.passportService.passport.endpoint)
